// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2rsUM","alert":"SettungsInbox_alert__264nI"};